/**
 * Created by jv on 08/02/2018.
 */
//js
const Shared = require("Sources/shared");
const LanguageManager = require("Sources/services/language-manager");
const utils = require("Sources/utils/utils");
const log = require("Sources/utils/logger")();

//Styles
require("Styles/pages/legal/terms-of-use.scss");

// Partial views
const htmlReq = require.context("Views/legal/partials", true, /terms-of-use\.html$/);

$(function () {
  Shared.shouldSetUpCreditsDialog = false;
  Shared.init();
  TermsOfUsePage.init();
});

let TermsOfUsePage = {};

((TermsOfUsePage) => {
  TermsOfUsePage.init = function () {
    setUpHtmlPartial();
  };

  function setUpHtmlPartial() {
    let htmlRequire = `./${LanguageManager.getCurrentLocale()}/terms-of-use.html`;
    let htmlPartial;

    let defaultRequire = "./default/terms-of-use.html";

    if (htmlReq.keys().includes(htmlRequire)) {
      htmlPartial = htmlReq(htmlRequire);
      $("#terms-of-use-content").html(htmlPartial);
    } else if (htmlReq.keys().includes(defaultRequire)) {
      htmlPartial = htmlReq(defaultRequire);
      $("#terms-of-use-content").html(htmlPartial);
    } else {
      log.error("Couldn't find html partial [%s] in known html partial list: %o", htmlRequire, htmlReq.keys());
      utils.redirect("/");
    }
  }
})(TermsOfUsePage);



// WEBPACK FOOTER //
// ./app/js/entries/legal/terms-of-use.js